<template>
  <div>
    <div v-if="successPost" class="d-flex justify-content-center">
      <div class="alert alert-success text-center w-95" role="alert">
        <span class="font-weight-bold">Your insurance data has been saved successfully !</span><br>
        <span class="font-size-small">You can check your insurance data by clicking on "View Previous" button.</span>
        <button @click="hideShowAlertMessage" type="button" class="float-right btn btn-outline-secondary btn-sm">X</button>
      </div>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.name.$touch()" v-model="userDataForm.name" type="text" name="clientName" id="clientName" class="form-control" placeholder="Enter your name">
            <div class="input-group-append">
              <label for="clientName" class="input-group-text bg-color-grey text-white">Name</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.name.$error">
            <span v-if="!$v.userDataForm.name.minLength" class="text-danger">* Name must have at least {{ $v.userDataForm.name.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.name.minLength && !$v.userDataForm.name.required">
            <span v-if="!$v.userDataForm.name.required" class="text-danger">* Please enter your name !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.address.$touch()" v-model="userDataForm.address" type="text" name="clientAddress" id="clientAddress" class="form-control" placeholder="Home address">
            <div class="input-group-append">
              <label for="clientAddress" class="input-group-text bg-color-grey text-white">Address</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.address.$error">
            <span v-if="!$v.userDataForm.address.minLength" class="text-danger">* Address must have at least {{ $v.userDataForm.address.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.address.minLength && !$v.userDataForm.address.required">
            <span v-if="!$v.userDataForm.address.required" class="text-danger">* Please enter home address !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="form-group w-md-45 mt-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text bg-color-grey text-white" for="clientCountry">Country</label>
            </div>
            <select @blur="$v.userDataForm.country.$touch()" v-model="userDataForm.country" class="form-control custom-select" name="clientCountry" id="clientCountry">
              <option value="no">Select a country</option>
              <optgroup :key="continent" :id="'country-optgroup-' + continent" :label="continent" v-for="(countries, continent) in listOfCountries">
                <option :key="index" :value="country[1]" :label="country[1] + ' (' + country[0] + ')' " v-for="(country, index) of countries">
                  {{ country[1] }} ({{ country[0] }})
                </option>
              </optgroup>
            </select>
          </div>
          <div v-if="$v.userDataForm.country.$error">
            <span v-if="!$v.userDataForm.country.minLength" class="text-danger">* Please enter a valid country</span>
            <br v-if="!$v.userDataForm.country.minLength && !$v.userDataForm.country.required">
            <span v-if="!$v.userDataForm.country.required" class="text-danger">* Please choose your country !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.zipcode.$touch()" v-model="userDataForm.zipcode" type="number" name="clientZipCode" id="clientZipCode" class="form-control" placeholder="Zip Code">
            <div class="input-group-append">
              <label for="clientZipCode" class="input-group-text bg-color-grey text-white">Zip Code</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.zipcode.$error">
            <span v-if="!$v.userDataForm.zipcode.numeric" class="text-danger">* Zip code must contain only digits !</span>
            <br v-if="!$v.userDataForm.zipcode.numeric && !$v.userDataForm.zipcode.minLength">
            <span v-if="!$v.userDataForm.zipcode.minLength" class="text-danger">* Please enter a zip code with at least {{ $v.userDataForm.zipcode.$params.minLength.min }} digits !</span>
            <br v-if="!$v.userDataForm.zipcode.required && !$v.userDataForm.zipcode.minLength">
            <span v-if="!$v.userDataForm.zipcode.required" class="text-danger">* Please enter a zip code !</span>
            <br v-if="!$v.userDataForm.zipcode.between">
            <span v-if="!$v.userDataForm.zipcode.between" class="text-danger">* Please enter a zip code between {{ $v.userDataForm.zipcode.$params.between.min }} and {{ $v.userDataForm.zipcode.$params.between.max }} !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.phonenumber.$touch()" v-model="userDataForm.phonenumber" type="number" name="clientPhoneNumber" id="clientPhoneNumber" class="form-control" placeholder="Phone Number">
            <div class="input-group-append">
              <label for="clientPhoneNumber" class="input-group-text bg-color-grey text-white">Telephone</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.phonenumber.$error">
            <span v-if="!$v.userDataForm.phonenumber.minLength" class="text-danger">* Please a phone number with at least {{ $v.userDataForm.phonenumber.$params.minLength.min }} digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.minLength && !$v.userDataForm.phonenumber.numeric">
            <span v-if="!$v.userDataForm.phonenumber.numeric" class="text-danger">* Phone number must contain only digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.numeric && !$v.userDataForm.phonenumber.required">
            <span v-if="!$v.userDataForm.phonenumber.required" class="text-danger">* Please enter a phone number !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.email.$touch()" v-model="userDataForm.email" type="text" name="clientEmail" id="clientEmail" class="form-control" placeholder="Email Address">
            <div class="input-group-append">
              <label for="clientEmail" class="input-group-text bg-color-grey text-white">Email Address</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.email.$error">
            <span v-if="!$v.userDataForm.email.email" class="text-danger">* Please enter a valid email address !</span>
            <br v-if="!$v.userDataForm.email.email && !$v.userDataForm.email.required">
            <span v-if="!$v.userDataForm.email.required" class="text-danger">* Please enter email address !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div>
          <div class="d-flex">
            <p class="w-25 pLabel mt-3"><span class="font-weight-bold">Marital Status :</span></p>
            <div class="mt-3 ml-3">
              <div class="custom-control custom-radio custom-control-inline" :key="index" v-for="(value, index) of maritalstatus">
                <input @blur="$v.userDataForm.maritalstatus.$touch()" v-model="userDataForm.maritalstatus" type="radio" :value="value" :id="value" name="clientMaritalStatus" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.maritalstatus.$error">
            <span v-if="!$v.userDataForm.maritalstatus.required" class="text-danger">* Please enter your marital status !</span>
          </div>
        </div>
        <div class="d-flex w-md-45">
          <div class="input-group">
            <p class="pLabel mt-3"><span class="font-weight-bold">Gender :</span></p>
            <div class="mt-3 ml-3">
              <div class="custom-control custom-radio custom-control-inline" :key="index" v-for="(value, index) of gender">
                <input @blur="$v.userDataForm.gender.$touch()" v-model="userDataForm.gender" type="radio" :value="value" :id="value" name="clientGender" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.gender.$error">
            <span v-if="!$v.userDataForm.gender.required" class="text-danger">* Please enter your gender !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <div class="input-group-append">
              <label for="clientDateOfBirth" class="input-group-text bg-color-grey text-white">Birth Date</label>
            </div>
            <input @blur="$v.userDataForm.datebirth.$touch()" v-model="userDataForm.datebirth" type="date" max="2001-01-01" name="clientDateOfBirth" id="clientDateOfBirth" class="form-control" placeholder="01/12/2015">
          </div>
          <div v-if="$v.userDataForm.datebirth.$error">
            <span v-if="!$v.userDataForm.datebirth.required" class="text-danger">* Please enter your birth date !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.datelicenced.$touch()" v-model="userDataForm.datelicenced" type="date" max="2019-06-30" name="clientDateLicenced" id="clientDateLicenced" class="form-control" placeholder="09/02/2017">
            <div class="input-group-append">
              <label for="clientDateLicenced" class="input-group-text bg-color-grey text-white">Date Licenced</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.datelicenced.$error">
            <span v-if="!$v.userDataForm.datelicenced.required" class="text-danger">* Please enter date of licence !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.licencenumber.$touch()" v-model="userDataForm.licencenumber" type="text" name="clientLicencedNumber" id="clientLicencedNumber" class="form-control" placeholder="Licence Number">
            <div class="input-group-append">
              <label for="clientLicencedNumber" class="input-group-text bg-color-grey text-white">Licence Number</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.licencenumber.$error">
            <span v-if="!$v.userDataForm.licencenumber.minLength" class="text-danger">* licence number must have at least {{ $v.userDataForm.licencenumber.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.licencenumber.minLength && !$v.userDataForm.licencenumber.required">
            <span v-if="!$v.userDataForm.licencenumber.required" class="text-danger">* Please enter your licence number !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.vehicleidnumber.$touch()" v-model="userDataForm.vehicleidnumber" type="text" name="clientVehicleIdNumber" id="clientVehicleIdNumber" class="form-control" placeholder="Vehicle ID Number">
            <div class="input-group-append">
              <label for="clientVehicleIdNumber" class="input-group-text bg-color-grey text-white">Vehicle ID</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.vehicleidnumber.$error">
            <span v-if="!$v.userDataForm.vehicleidnumber.minLength" class="text-danger">* Vehicle id number must have at least {{ $v.userDataForm.vehicleidnumber.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.vehicleidnumber.minLength && !$v.userDataForm.vehicleidnumber.required">
            <span v-if="!$v.userDataForm.vehicleidnumber.required" class="text-danger">* Please enter your vehicle id number !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="form-group w-md-45 mt-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text bg-color-grey text-white" for="vehicleYear">Vehicle Year</label>
            </div>
            <select @blur="$v.userDataForm.year.$touch()" v-model="userDataForm.year" class="form-control" name="vehicleYear" id="vehicleYear">
              <option value="none">Select a year</option>
              <option :key="index" :value="year" :label="year" v-for="(year, index) of years">{{ year }}</option>
            </select>
          </div>
          <div v-if="$v.userDataForm.year.$error">
            <span v-if="!$v.userDataForm.year.numeric" class="text-danger">* Please enter a valid year !</span>
            <br v-if="!$v.userDataForm.year.numeric && !$v.userDataForm.year.required">
            <span v-if="!$v.userDataForm.year.required" class="text-danger">* Please enter your vehicle year !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.make.$touch()" v-model="userDataForm.make" type="text" name="vehicleMaker" id="vehicleMaker" class="form-control" placeholder="Vehicle Maker">
            <div class="input-group-append">
              <label for="vehicleMaker" class="input-group-text bg-color-grey text-white">Vehicle Maker</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.make.$error">
            <span v-if="!$v.userDataForm.make.required" class="text-danger">* Please enter your vehicle maker !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.model.$touch()" v-model="userDataForm.model" type="text" name="vehicleModel" id="vehicleModel" class="form-control" placeholder="Vehicle Model">
            <div class="input-group-append">
              <label for="vehicleModel" class="input-group-text bg-color-grey text-white">Vehicle Model</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.model.$error">
            <span v-if="!$v.userDataForm.model.required" class="text-danger">* Please enter your vehicle maker !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.annualmillage.$touch()" v-model="userDataForm.annualmillage" type="number" name="vehicleAnnualMillage" id="vehicleAnnualMillage" class="form-control" placeholder="Vehicle Annual Millage">
            <div class="input-group-append">
              <label for="vehicleAnnualMillage" class="input-group-text bg-color-grey text-white">Annual Millage</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.annualmillage.$error">
            <span v-if="!$v.userDataForm.annualmillage.numeric" class="text-danger">* Annual millage must contain only digits !</span>
            <br v-if="!$v.userDataForm.annualmillage.numeric && !$v.userDataForm.annualmillage.required">
            <span v-if="!$v.userDataForm.annualmillage.required" class="text-danger">* Please enter your annual millage !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="d-flex w-md-45">
          <div class="input-group">
            <p class="pLabel mt-3"><span class="font-weight-bold">Usage :</span></p>
            <div class="mt-3 ml-3">
              <div class="custom-control custom-checkbox custom-control-inline" :key="index" v-for="(value, index) of usage">
                <input @blur="$v.userDataForm.usage.$touch()" v-model="userDataForm.usage" type="checkbox" :value="value" :id="value" name="clientUsage" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.usage.$error">
            <span v-if="!$v.userDataForm.usage.required" class="text-danger">* Please enter your vehicle usage !</span>
          </div>
        </div>
      </div>
      <div class="text-center mb-5">
        <button type="submit" class="mt-5 btn bg-color-grey text-white" :disabled="$v.userDataForm.$invalid">Submit</button>
        <div class="divEmptyBox text-center" v-if="$v.userDataForm.$invalid" v-on:click="$store.state.invalidFormAlert">
          <div class="emptyBox"><span class="invisible">Submit</span></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FORM_AUTO_VALIDATIONS } from '../../../../validations/formAuto'
export default {
  name: 'InsuranceFormAuto',
  // Get insurance type selected by user and fontStyle
  props: {
    insuranceType: {
      type: String
    },
    defaultFontStyle: {
      type: String,
      default: 'font-normal'
    }
  },
  data () {
    return {
      listOfCountries: this.$store.state.countries,
      years: this.$store.state.years,
      maritalstatus: this.$store.state.maritalstatus,
      gender: this.$store.state.gender,
      usage: this.$store.state.usage,
      userDataForm: {
        name: null,
        address: null,
        country: null,
        zipcode: null,
        phonenumber: null,
        email: null,
        maritalstatus: null,
        gender: null,
        datebirth: null,
        datelicenced: null,
        licencenumber: null,
        vehicleidnumber: null,
        year: null,
        make: null,
        model: null,
        annualmillage: null,
        usage: []
      },
      successPost: false
    }
  },
  methods: {
    // show success message if insurance data have been posted successfully
    hideShowAlertMessage () {
      this.successPost = !this.successPost
    },
    // Post insurance object after successfully submission
    onSubmit () {
      let type = null
      this.insuranceType === 'AppInsuranceFormAuto' ? type = 'Auto' : type = null
      console.log('insuranceType = ' + type)
      const formData = {
        typeinsurance: type,
        ownerinsurance: this.$store.getters.email,
        name: this.userDataForm.name,
        address: this.userDataForm.address,
        country: this.userDataForm.country,
        zipcode: this.userDataForm.zipcode,
        phonenumber: this.userDataForm.phonenumber,
        email: this.userDataForm.email,
        maritalstatus: this.userDataForm.maritalstatus,
        gender: this.userDataForm.gender,
        datebirth: this.userDataForm.datebirth,
        datelicenced: this.userDataForm.datelicenced,
        licencenumber: this.userDataForm.licencenumber,
        vehicleidnumber: this.userDataForm.vehicleidnumber,
        year: this.userDataForm.year,
        make: this.userDataForm.make,
        model: this.userDataForm.model,
        annualmillage: this.userDataForm.annualmillage,
        usage: this.userDataForm.usage.toString()
      }
      console.log(formData)
      this.$store.dispatch('postInsurance', formData)
        .then(isSuccess => {
          isSuccess === true ? this.successPost = true : this.successPost = false
          console.log('response axios post insurance = ' + isSuccess)
        })
    }
  },
  // Load validations requirements of the insurance form
  validations: FORM_AUTO_VALIDATIONS
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/forms/InsuranceFormAuto.vue